import React, { Component } from 'react'
import KeyCap from '../Key/Key'
import style from './Keyboard.scss'

class Keyboard extends Component {
  render() {
    return (
      <div
        className={style.keyboard}
        style={{ background: this.props.theme.caseColor.color }}
      >
        {this.props.layout.keys.map((keyCap, i) => {
          return (
            <KeyCap
              keyData={keyCap}
              theme={this.props.theme}
              legendSet={0}
              key={i}
            />
          )
        })}
      </div>
    )
  }
}

export default Keyboard



// WEBPACK FOOTER //
// ./src/components/Keyboard/Keyboard.js